import { injectable } from 'inversify';
import Peer from './Peer';

@injectable()
export class MyPeer {
  id?: Peer['id'];

  private peer?: Peer;

  get(): Peer | undefined {
    return this.peer;
  }

  set(peer: Peer): void {
    this.peer = peer;
  }

  delete(): void {
    this.peer = undefined;
  }

  get canPublish(): boolean {
    return this.peer?.role === 'host';
  }
}
